<template>
  <fine-makeinvoice-check
    :sna-id="snaId"
    :pagetitle="`罚没金开票审批`"
  >

  </fine-makeinvoice-check>
</template>

<script>

import FineMakeinvoiceCheck from '@/views/workbench/workCheckManage/makeinvoiceCheck/fineMakeinvoiceCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'

export default {
  name: 'fineMakeinvoiceCheckDetail',
  mixins: [checkMixin, routerMixin],
  components: { FineMakeinvoiceCheck },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
